import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import React, { useEffect, useReducer } from 'react';

import { ProductCategoryColor } from '@/types/productCategory';

function reducer(state: { value: number }, action: { type: any }) {
  switch (action.type) {
    case 'INCREMENT':
      return { value: state.value + 1 };
    case 'DECREMENT':
      return { value: state.value > 0 ? state.value - 1 : 0 };
    default:
      return state;
  }
}

interface NumberFieldProps {
  color: Pick<ProductCategoryColor, 'border' | 'text'>;
  onChange: (e: number) => void;
  variant: 'ticket' | 'order';
  defaultValue?: number;
  withBorder?: boolean;
  disabled?: boolean;
}
const NumberField = ({
  color,
  onChange,
  variant,
  defaultValue = 0,
  withBorder = true,
  disabled = false,
}: NumberFieldProps) => {
  const [state, dispatch] = useReducer(reducer, { value: defaultValue });
  useEffect(() => {
    onChange(state.value);
  }, [state.value]);

  return (
    <div
      className={clsx(`relative z-[1] flex max-w-min rounded-xl p-2`, {
        'border border-white-filled-default':
          variant === 'ticket' && withBorder,
        'border border-neutral-faded-default':
          variant === 'order' && withBorder,
      })}
    >
      <button
        type='button'
        onClick={() => dispatch({ type: 'DECREMENT' })}
        className={clsx('rounded-full')}
      >
        <MinusCircleIcon
          className={clsx(`${color.text} h-5 w-5 stroke-2`, {
            [`opacity-10`]: state.value === 0,
          })}
        />
      </button>

      <input
        type='text'
        value={state.value}
        readOnly
        className={`${color.text}  text-white pointer-events-none w-20 select-none bg-transparent text-center`}
      />
      <button
        type='button'
        id='addItem'
        disabled={disabled}
        onClick={() => {
          dispatch({ type: 'INCREMENT' });
        }}
      >
        <PlusCircleIcon
          className={clsx(`${color.text} h-5 w-5 stroke-2`, {
            [`opacity-10`]: disabled,
          })}
        />
      </button>
    </div>
  );
};

export default NumberField;
